export const ACCESS_TYPE_ALL_TASKS = "allTaskIncludesFuture";
export const ACCESS_TYPE_SELECTED_TASKS = "selectedTask";

export type ForeignEntityAccountantAccessType =
  | typeof ACCESS_TYPE_ALL_TASKS
  | typeof ACCESS_TYPE_SELECTED_TASKS;
